import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsEquipmentStatus, PmsEquipmentStatus } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsEquipmentStatus>
    useData={usePmsEquipmentStatus}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
